import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "../rest/RestoForm.css";
import { Typography, Tabs, Tab, Box, Alert } from '@mui/material';

const RestForm = () => {
  const [users, setUsers] = useState([]);
  const [contractors, setContractors] = useState([]);
  const [restaurants, setRestaurants] = useState([]);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [activeTab, setActiveTab] = useState(0);
  const [formData, setFormData] = useState({
    user_id: '',
    contractor_id: '',
    restaurant_id: '',
    contractor_name: '',
    restaurant_name: '',
    uid: '',
    type: 'solo'
  });
  const [values, setValues] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    region: "uk-UA",
    token: "",
    discount: ""
  });
  
  const [userHasContractor, setUserHasContractor] = useState(false);
  const [emailAlreadyExists, setEmailAlreadyExists] = useState(false);
  const [usernameAlreadyExists, setUsernameAlreadyExists] = useState(false);
  const [passwordMatch, setPasswordMatch] = useState(true);
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([
          fetchUsers(),
          fetchContractors(),
          fetchRestaurants()
        ]);
      } catch (error) {
        console.error('Error fetching data:', error);
        setError('Помилка при завантаженні даних');
      }
    };
    
    fetchData();
  }, []);

  const fetchUsers = async () => {
    try {
      const { data } = await axios.get('https://test2.planfix-to-syrve.com/users');
      console.log('Fetched users:', data);
      setUsers(data);
    } catch (error) {
      console.error('Error fetching users:', error);
      setError('Помилка при завантаженні користувачів');
      throw error;
    }
  };

  const fetchContractors = async () => {
    try {
      const { data } = await axios.get('https://test2.planfix-to-syrve.com/contractors');
      setContractors(data);
    } catch (error) {
      setError('Помилка при завантаженні контрагентів');
      throw error;
    }
  };

  const fetchRestaurants = async () => {
    try {
      const { data } = await axios.get('https://test2.planfix-to-syrve.com/restaurants');
      setRestaurants(data);
    } catch (error) {
      setError('Помилка при завантаженні ресторанів');
      throw error;
    }
  };

  const checkUserContractor = async (userId) => {
    try {
      const { data } = await axios.get(`https://test2.planfix-to-syrve.com/check-user-contractor/${userId}`);
      setUserHasContractor(data.hasContractor);
      if (data.hasContractor) {
        setError('У співробітника вже є контрагент');
        setSuccess('');
      } else {
        setError('');
      }
    } catch (error) {
      console.error('Error checking user contractor:', error);
      setError('Помилка при перевірці контрагента');
      setSuccess('');
    }
  };

  const handleChange = ({ target: { name, value } }) => {
    setFormData(prev => ({ ...prev, [name]: value }));
    if (name === 'user_id') {
      checkUserContractor(value);
    }
    setError('');
    setSuccess('');
  };

  const handleRegisterChange = (event) => {
    const { name, value } = event.target;
    setValues({ ...values, [name]: value });
    
    if (name === 'username') {
      setUsernameAlreadyExists(false);
    }
    if (name === 'email') {
      setEmailAlreadyExists(false);
    }
    if (name === 'password' || name === 'confirmPassword') {
      setPasswordMatch(true);
    }
    
    setError('');
    setSuccess('');
    setValidationErrors({});
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (userHasContractor) {
      setError('У співробітника вже є контрагент');
      setSuccess('');
      return;
    }
    if (!formData.user_id) {
      setError('Будь ласка, виберіть співробітника');
      setSuccess('');
      return;
    }
    try {
      await axios.post('https://test2.planfix-to-syrve.com/add-contractor-to-user', {
        user_id: parseInt(formData.user_id),
        contractor_name: formData.contractor_name,
      });
      
      await fetchContractors();
      setFormData(prev => ({ ...prev, contractor_name: '' }));
      setError('');
      setSuccess('компанію успішно додано до співробітника');
    } catch (error) {
      console.error('Error adding contractor to user:', error);
      setError(error.response?.data?.message || 'Помилка при додаванні контрагента');
      setSuccess('');
    }
  };

  const handleRegisterSubmit = async (event) => {
    event.preventDefault();
    
    setEmailAlreadyExists(false);
    setUsernameAlreadyExists(false);
    setPasswordMatch(true);
    setValidationErrors({});
    
    const errors = {};
    
    if (!values.username.trim()) {
      errors.username = "Введіть ім'я користувача";
    } else if (values.username.length < 3) {
      errors.username = "Ім'я користувача має містити мінімум 3 символи";
    }
    
    if (!values.email.trim()) {
      errors.email = "Введіть email";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
      errors.email = "Введіть коректний email";
    }
    
    if (!values.password) {
      errors.password = "Введіть пароль";
    } else if (values.password.length < 6) {
      errors.password = "Пароль має містити мінімум 6 символів";
    }
    
    if (values.password !== values.confirmPassword) {
      errors.confirmPassword = 'Паролі не співпадають';
      setPasswordMatch(false);
    }
    
    if (values.discount && !/^\d*\.?\d*$/.test(values.discount)) {
      errors.discount = "Введіть коректне число";
    }
    
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      setError('Будь ласка, виправте помилки у формі');
      return;
    }
    
    try {
      const userData = {
        username: values.username.trim(),
        email: values.email.trim().toLowerCase(),
        password: values.password,
        region: values.region || 'uk-UA',
        token: values.token.trim() || "",
        discount: values.discount ? parseFloat(values.discount) : 0
      };
      
      console.log('Відправляємо дані на сервер:', {
        ...userData,
        password: '***'
      });
      
      const res = await axios.post("https://test2.planfix-to-syrve.com/signup", userData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      console.log('Відповідь сервера:', res.data);
      
      if (res.data.success || res.status === 200 || res.status === 201) {
        setSuccess('Співробітника успішно зареєстровано');
        setError('');
        
        await fetchUsers();
        
        setValues({
          username: "",
          email: "",
          password: "",
          confirmPassword: "",
          region: "uk-UA",
          token: "",
          discount: ""
        });
        setValidationErrors({});
      } else {
        setError(res.data.message || 'Помилка при реєстрації');
      }
      
    } catch (error) {
      console.error('Registration error details:', {
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        message: error.message
      });
      
      
      if (error.response) {
        const serverData = error.response.data;
        const serverMessage = serverData?.message || serverData?.error || '';
        
        console.log('Server response data:', serverData);
        
        
        if (serverMessage.toLowerCase().includes('email') && 
            (serverMessage.toLowerCase().includes('exist') || 
             serverMessage.toLowerCase().includes('існує') ||
             serverMessage.toLowerCase().includes('taken') ||
             serverMessage.toLowerCase().includes('duplicate'))) {
          setEmailAlreadyExists(true);
          setError('Користувач з таким email вже існує');
        } 
        else if (serverMessage.toLowerCase().includes('username') && 
                 (serverMessage.toLowerCase().includes('exist') || 
                  serverMessage.toLowerCase().includes('існує') ||
                  serverMessage.toLowerCase().includes('taken'))) {
          setUsernameAlreadyExists(true);
          setError('Користувач з таким іменем вже існує');
        }
        else if (serverData?.field === 'email') {
          setEmailAlreadyExists(true);
          setError('Користувач з таким email вже існує');
        } 
        else if (serverData?.field === 'username') {
          setUsernameAlreadyExists(true);
          setError('Користувач з таким іменем вже існує');
        }
        else if (error.response.status === 400) {
          
          setError(serverMessage || 'Помилка валідації даних. Перевірте правильність заповнення полів.');
        }
        else if (error.response.status === 409) {
          setError('Користувач з такими даними вже існує');
        }
        else {
          setError(serverMessage || 'Помилка при реєстрації співробітника. Спробуйте пізніше.');
        }
      } else if (error.request) {
        console.error('No response received:', error.request);
        setError('Сервер не відповідає. Перевірте підключення до інтернету.');
      } else {
        console.error('Error setting up request:', error.message);
        setError('Помилка при відправці запиту. Спробуйте ще раз.');
      }
      
      setSuccess('');
    }
  };
  
  const handleAddRestaurant = async (event) => {
    event.preventDefault();
    try {
      await axios.post('https://test2.planfix-to-syrve.com/add-restaurant-to-contractor', {
        contractor_id: formData.contractor_id,
        restaurant_name: formData.restaurant_name,
        uid: formData.uid,
      });

      await fetchRestaurants();
      setFormData(prev => ({ ...prev, restaurant_name: '', uid: '' }));
      setSuccess('Ресторан успішно додано');
      setError('');
    } catch (error) {
      console.error('Error adding restaurant:', error);
      setError(error.response?.data?.message || 'Помилка при додаванні ресторану');
      setSuccess('');
    }
  };

  const handleAddContractor = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post('https://test2.planfix-to-syrve.com/add-contractor', {
        name: formData.contractor_name,
        type: 'solo'
      });
  
      console.log('Created contractor:', response.data);
      
      await fetchContractors();
      
      setFormData(prev => ({ ...prev, contractor_name: '' }));
      setSuccess('компанію успішно створено');
      setError('');
    } catch (error) {
      console.error('Error adding contractor:', error);
      setError(error.response?.data?.message || 'Помилка при створенні контрагента');
      setSuccess('');
    }
  };

  const renderAddUserContractorForm = () => (
    <form onSubmit={handleSubmit}>
      {(error || success) && (
        <Alert 
          severity={error ? "error" : "success"} 
          style={{ marginBottom: "10px" }}
        >
          {error || success}
        </Alert>
      )}
      <select
        className="input-stl"
        style={{ marginTop: "10px", backgroundColor: "rgb(213, 220, 255)", width: '100%', padding: '8px' }}
        name="user_id"
        value={formData.user_id}
        onChange={handleChange}
        required
      >
        <option value="">Виберіть співробітника</option>
        {users.map((user) => (
          <option key={user.id} value={user.id}>
            {user.username || user.email} (ID: {user.id}) {user.discount ? `- Знижка: ${user.discount}%` : ''}
          </option>
        ))}
      </select>
      <select
        className="input-stl"
        style={{ marginTop: "10px", backgroundColor: "rgb(213, 220, 255)", width: '100%', padding: '8px' }}
        name="contractor_name"
        value={formData.contractor_name}
        onChange={handleChange}
        disabled={userHasContractor}
        required
      >
        <option value="">Виберіть компанію</option>
        {Array.from(new Set(contractors.map(c => c.name))).map(name => (
          <option key={name} value={name}>{name}</option>
        ))}
      </select>
      <button
        className="input-stl"
        style={{ 
          marginTop: "15px", 
          width: '100%',
          padding: '10px',
          backgroundColor: userHasContractor ? '#ccc' : '#4CAF50',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: userHasContractor ? 'not-allowed' : 'pointer'
        }}
        type="submit"
        disabled={userHasContractor}
      >
        Додати компанію до співробітника
      </button>
    </form>
  );

  const renderAddNewContractorForm = () => (
    <form onSubmit={handleAddContractor}>
      {(error || success) && (
        <Alert 
          severity={error ? "error" : "success"} 
          style={{ marginBottom: "10px" }}
        >
          {error || success}
        </Alert>
      )}
      <input
        className="input-stl"
        style={{ 
          marginTop: "10px", 
          backgroundColor: "rgb(213, 220, 255)",
          width: '100%',
          padding: '8px',
          boxSizing: 'border-box'
        }}
        type="text"
        name="contractor_name"
        value={formData.contractor_name}
        onChange={handleChange}
        placeholder="Назва нової компанії"
        required
      />
      <button
        className="input-stl"
        style={{ 
          marginTop: "15px",
          width: '100%',
          padding: '10px',
          backgroundColor: '#4CAF50',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
        type="submit"
      >
        Додати нову компанію
      </button>
    </form>
  );

  const renderAddNewUserForm = () => (
    <form onSubmit={handleRegisterSubmit}>
      {(error || success) && (
        <Alert 
          severity={error ? "error" : "success"} 
          style={{ marginBottom: "20px" }}
        >
          {error || success}
        </Alert>
      )}
      
      <div style={{ width: '100%', maxWidth: '400px', margin: '0 auto' }}>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Username:
          </label>
          <input
            className="input-stl"
            style={{
              width: '100%',
              padding: '8px',
              boxSizing: 'border-box',
              backgroundColor: "rgb(213, 220, 255)",
              border: usernameAlreadyExists || validationErrors.username ? '2px solid red' : '1px solid #ccc',
              borderRadius: '4px'
            }}
            placeholder="Username"
            type="text"
            name="username"
            value={values.username}
            onChange={handleRegisterChange}
            required
          />
          {usernameAlreadyExists && (
            <Typography variant="caption" color="error" style={{ display: 'block', marginTop: '4px' }}>
              Користувач з таким іменем вже існує
            </Typography>
          )}
          {validationErrors.username && !usernameAlreadyExists && (
            <Typography variant="caption" color="error" style={{ display: 'block', marginTop: '4px' }}>
              {validationErrors.username}
            </Typography>
          )}
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Email:
          </label>
          <input
            className="input-stl"
            style={{
              width: '100%',
              padding: '8px',
              boxSizing: 'border-box',
              backgroundColor: "rgb(213, 220, 255)",
              border: emailAlreadyExists || validationErrors.email ? '2px solid red' : '1px solid #ccc',
              borderRadius: '4px'
            }}
            placeholder="Email"
            type="email"
            name="email"
            value={values.email}
            onChange={handleRegisterChange}
            required
          />
          {emailAlreadyExists && (
            <Typography variant="caption" color="error" style={{ display: 'block', marginTop: '4px' }}>
              Користувач з таким email вже існує
            </Typography>
          )}
          {validationErrors.email && !emailAlreadyExists && (
            <Typography variant="caption" color="error" style={{ display: 'block', marginTop: '4px' }}>
              {validationErrors.email}
            </Typography>
          )}
        </div>
        
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Password:
          </label>
          <input
            className="input-stl"
            style={{
              width: '100%',
              padding: '8px',
              boxSizing: 'border-box',
              backgroundColor: "rgb(213, 220, 255)",
              border: validationErrors.password ? '2px solid red' : '1px solid #ccc',
              borderRadius: '4px'
            }}
            placeholder="Password"
            type="password"
            name="password"
            value={values.password}
            onChange={handleRegisterChange}
            required
          />
          {validationErrors.password && (
            <Typography variant="caption" color="error" style={{ display: 'block', marginTop: '4px' }}>
              {validationErrors.password}
            </Typography>
          )}
        </div>
        
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Confirm Password:
          </label>
          <input
            className="input-stl"
            style={{
              width: '100%',
              padding: '8px',
              boxSizing: 'border-box',
              backgroundColor: "rgb(213, 220, 255)",
              border: !passwordMatch || validationErrors.confirmPassword ? '2px solid red' : '1px solid #ccc',
              borderRadius: '4px'
            }}
            placeholder="Confirm Password"
            type="password"
            name="confirmPassword"
            value={values.confirmPassword}
            onChange={handleRegisterChange}
            required
          />
          {!passwordMatch && (
            <Typography variant="caption" color="error" style={{ display: 'block', marginTop: '4px' }}>
              Паролі не співпадають
            </Typography>
          )}
          {validationErrors.confirmPassword && passwordMatch && (
            <Typography variant="caption" color="error" style={{ display: 'block', marginTop: '4px' }}>
              {validationErrors.confirmPassword}
            </Typography>
          )}
        </div>
        
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Знижка (%):
          </label>
          <input
            className="input-stl"
            style={{
              width: '100%',
              padding: '8px',
              boxSizing: 'border-box',
              backgroundColor: "rgb(213, 220, 255)",
              border: validationErrors.discount ? '2px solid red' : '1px solid #ccc',
              borderRadius: '4px'
            }}
            placeholder="Введіть розмір знижки (наприклад, 10.5)"
            type="text"
            name="discount"
            value={values.discount}
            onChange={handleRegisterChange}
          />
          {validationErrors.discount && (
            <Typography variant="caption" color="error" style={{ display: 'block', marginTop: '4px' }}>
              {validationErrors.discount}
            </Typography>
          )}
          <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginTop: '4px' }}>
            Якщо не вказано, буде встановлено 0%
          </Typography>
        </div>
        
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Номер телефону:
          </label>
          <input
            className="input-stl"
            style={{
              width: '100%',
              padding: '8px',
              boxSizing: 'border-box',
              backgroundColor: "rgb(213, 220, 255)",
              border: '1px solid #ccc',
              borderRadius: '4px'
            }}
            placeholder="Номер телефону"
            type="text"
            name="token"
            value={values.token}
            onChange={handleRegisterChange}
          />
        </div>
              <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
           City:
          </label>
          <input
            className="input-stl"
            style={{
              width: '100%',
              padding: '8px',
              boxSizing: 'border-box',
              backgroundColor: "rgb(213, 220, 255)",
              border: '1px solid #ccc',
              borderRadius: '4px'
            }}
            placeholder="City"
            type="City"
            name="City"
            value={values.city}
            onChange={handleRegisterChange}
          />
        </div>
        
        <button
          className="input-stl"
          type="submit"
          style={{
            width: '100%',
            padding: '10px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: 'bold',
            marginTop: '10px'
          }}
        >
          Створити нового співробітника
        </button>
      </div>
    </form>
  );

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setError('');
    setSuccess('');
    setFormData({
      user_id: '',
      contractor_id: '',
      restaurant_id: '',
      contractor_name: '',
      restaurant_name: '',
      uid: '',
      type: 'solo'
    });
    setValues({
      username: "",
      email: "",
      password: "",
      confirmPassword: "",
      region: "uk-UA",
      token: "",
      discount: ""
    });
    setEmailAlreadyExists(false);
    setUsernameAlreadyExists(false);
    setPasswordMatch(true);
    setValidationErrors({});
  };

  return (
    <div className="br-m">
      <div className="container-about-ll">
        <Typography variant="h5" gutterBottom style={{ textAlign: 'center', marginBottom: '20px', marginTop: "60px" }}>
          Управління компаніями та користувачами
        </Typography>
        
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange}
            centered
          >
            <Tab label="Додати компанію до співробітника" />
            <Tab label="Додати компанію" />
            <Tab label="Додати нового співробітника" />
          </Tabs>
        </Box>

        <Box sx={{ padding: 3 }}>
          {activeTab === 0 && (
            <Box>
              <Typography variant="h6" gutterBottom>
                Додати компанію до існуючого співробітника
              </Typography>
              {renderAddUserContractorForm()}
            </Box>
          )}
          
          {activeTab === 1 && (
            <Box>
              <Typography variant="h6" gutterBottom>
                Створити нову компанію
              </Typography>
              {renderAddNewContractorForm()}
            </Box>
          )}
          
          {activeTab === 2 && (
            <Box>
              <Typography variant="h6" gutterBottom>
                Створити нового співробітника
              </Typography>
              {renderAddNewUserForm()}
            </Box>
          )}
        </Box>
      </div>
    </div>
  );
};

export default RestForm;